import $ from "jquery";
import "jquery-ui-dist";
import moment from "moment";
import { inject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { AuthService } from "../../services/authService";
import { UserMessageService } from "../../services/userMessageService";
import { ExpertTipVideoYTManagerAPI } from "../../services/ytmanager/expertTipVideoYTManagerAPI";
import { AccountYTManagerAPI } from "../../services/ytmanager/accountYTManagerAPI";
@inject(AuthService, Router, ExpertTipVideoYTManagerAPI, AccountYTManagerAPI, UserMessageService)
export class ExpertVideoTip  {
  constructor(authService, router, api, accountApi, userMessageService) {
    this.authService = authService;
    this.router = router;
    this.api = api;
    this.accountApi = accountApi;
    this.userMessageService = userMessageService;
    this.whitelabel_id = null;
    this.saving = false;
    this.editable = true;
    this.loading = true;
    this.app_name = "Magnfi";
    this.file_name = null;

    if (window.whitelabel) {
      this.app_name = window.app_name;
    }

    this.concent=false;
    this.subjectMax = 64;
    this.bodyMax = 500;
    this.ctaLinkMax = 500;
    this.ctaTextMax = 20;
    this.instructionsMax=500;


    this.showCustomFrameSave = false;

    this.search_contact = "";

    this.id = null;
    this.email = null;
    this.firstName = null;
    this.lastName = null;
    this.isWLAdmin = false;
    this.topics = [
      {
        description: "",
        date:  moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        instructionsCharsLeft:500


      },
      {
        description: "",
        date:  moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        instructionsCharsLeft:500

      },
    ];

    this.load_users();
  }

  addTopic() {
    this.topics.push({
      description: "",
      date:  moment(new Date()).format("YYYY-MM-DDTHH:mm"),
      instructionsCharsLeft:500

    });
  }

  submit() {
    if (this.isValidate()) {
        this.topics=this.topics.map(topic=>{
          console.log(`Updating topic: ${JSON.stringify(topic)}`);
        topic['date'] = this.getGMTDatetime(topic.date);
        console.log(`Updating topic: ${JSON.stringify(topic)}`);

        return topic;
      })
      console.log('Updated topics:', JSON.stringify(this.topics));
      this.saving = true;
      this.api.create(
        this.authService.getUser().token,
        {topics :JSON.parse(JSON.stringify(this.topics)),id:this.id},
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this)
      );
    }
  }

  switchUser(){
    this.email=null;
    this.firstName=null;
    this.lastName=null;
    this.search_contact = "";
  }
  isValidate() {
    let valid = true;
    this.topics.forEach((topic) => {
      if (
        topic.description.trim() == "" ||
        !topic.date
      ) {
        this.userMessageService.setUserError(
          "user",
          "Information cannot be empty"
        );
        valid = false;
      }
    });

    if(!this.id){
      this.userMessageService.setUserError(
        "user",
        "User Not selected"
      );
      return false 
    }

    return valid;
  }
  activate(params, route) {
    this.id = params.userId;
    // this.email=null;
    this.search_contact=""


  }

  attached() {
    if(this.id)
    this.accountApi.getUserData(
      this.id,
      this.authService.getUser().token,
      this.userLoadSuccess.bind(this),
      this.userLoadFailed.bind(this)
    );
  }

  userLoadSuccess(data) {
    this.firstName=data.user.first_name;
    this.lastName=data.user.last_name;
    this.email=data.user.email;
  }
  errorCallback(msg) {
    console.log(msg);
  }

  userLoadFailed(msg) {
    console.log(msg)
  }

  detached() {}

  autofill(event, ui) {
    this.firstName = ui.item.value.first_name;
    this.lastName = ui.item.value.last_name;
    this.email = ui.item.value.email;
    this.router.navigate('/ytmanager/expertTipVideo/'+ui.item.value.id)

  }
  contacts_autocomplete(data) {
    $("#contacts_search").data().autocomplete = null;
    $("#contacts_search").autocomplete({
      source: data.list.map((user) => {
        return {
          label: `${user.first_name} ${user.last_name}, ${user.email}`,
          value: user,
        };
      }),
      minLength: 1,
      select: this.autofill.bind(this),
    });
  }


  instructionsKeyUp(index) {
    var len = this.topics[index].description.length;

    if (len > this.instructionsMax) {
        this.topics[index].description = this.topics[index].description.substring(0, this.instructionsMax);
    } else {
        this.topics[index].instructionsCharsLeft = this.instructionsMax - len;
    }
}

getGMTDatetime(date){
  //https://stackoverflow.com/questions/26392280/using-momentjs-to-convert-date-to-epoch-then-back-to-date
      //get the timestamp of date entered in miliseconds
      var timestamp_miliseconds = moment(date,  "YYYY-MM-DDTHH:mm").valueOf();
      return timestamp_miliseconds/1000; //convert back to seconds from miliseconds
}

  instructionsChanged(index) {
    if (this.topics[index].title != -1)
        this.topics[index].description =this.topics[index].title;
    else
      this.topics[index].description = "";

    this.instructionsKeyUp(index);

    // this.instructionsCtrl.focus();

}

  handleKeypress(event) {
    this.load_users();
  }

  load_users() {
    this.accountApi.getUserList(
      this.search_contact,
      null,
      1,
      10,
      null,
      null,
      this.authService.getUser().token,
      this.contacts_autocomplete.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  reset() {
    this.topics = [
      {
        title:"",
        description: "",
        date:  moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        instructionsCharsLeft:500


      },
      {
        title:"",
        description: "",
        date:  moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        instructionsCharsLeft:500

      },
    ];
  }

  saveLoadSuccess(data) {
    this.userMessageService.setUserMessage("user", "Saved!");
    this.reset();
    setTimeout(()=>{
      window.location.href="/#/ytmanager/expertTipVideo"
      this.switchUser();
    },1500)
  }
  saveLoadError(msg) {
    this.sending = false;
    this.saving = false;
    this.deleting = false;
    this.userMessageService.setUserError("user", msg);
  }


  setData(data) {
    console.log(data);
    this.onresize();
    this.account_owner_user_id = data.account_owner_user_id;
    this.customer_first_name = data.customer_first_name;
    this.customer_last_name = data.customer_last_name;
    this.customer_name =
      data.customer_first_name + " " + data.customer_last_name;
    this.customer_email = data.customer_email;

    if (data.gmt_time !== null && data.gmt_time != 0 && data.gmt_time != "") {
      this.dateEntered = moment(data.gmt_time * 1000).format(
        "MM/DD/YYYY hh:mm A"
      );
    } else {
      this.dateEntered = moment().format("MM/DD/YYYY hh:mm A");
    }

  }

  getData(isGmtTime = true) {}

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailReg.test(email);
  }
}
